import React from "react";

const Support = () => {
  return (
    <div className="page-container" style={{ padding: 24 }}>
      <h2>Support</h2>
      <p>
        Need help? Email our support team at{" "}
        <a href="mailto:thulani@autopromote.org">thulani@autopromote.org</a> or use the contact
        page.
      </p>
    </div>
  );
};

export default Support;
